/**
 * CANDIDATE COPY, not approved: awaiting Charles's approval before merge (verifime-adr#617).
 *
 * Every string NewIdentityCard shows by default. `cardLabel` and `rowLabel` are new copy and carry
 * the marker. `selected` is the same word as on the identity card, so it is not repeated here: it
 * comes from requestIdentityCardCopy.ts, where it carries the marker. The caller can replace any
 * of them through props.
 */
import { REQUEST_IDENTITY_CARD_COPY } from '../RequestIdentityCard/requestIdentityCardCopy';

export const NEW_IDENTITY_CARD_COPY = {
  // The "Selected" pill is the same word on every chosen card, so it has one source.
  selected: REQUEST_IDENTITY_CARD_COPY.selected,
  // CANDIDATE COPY, not approved (verifime-adr#617)
  cardLabel: (entityTypeLabel: string) => `A new ${entityTypeLabel}`,
  // CANDIDATE COPY, not approved (verifime-adr#617)
  rowLabel: (entityTypeLabel: string) => `Verify a new ${entityTypeLabel}`,
};
